import { useState } from 'react';
import { useQuery } from 'react-query';
import TableForm from 'components/common/lists/TableForm';
import ScoreDatail from 'pages/modal/ScoreDatail';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import styles from 'styles/components/common/lists/Table.module.scss';
import { ReactComponent as ChevronRightIcon } from 'assets/icons/chevron_right.svg';
import { TTableHeader } from 'types/components/table';
import { TTablePaging } from 'types/components/table';
import { TScoreTableInfo, TScoreDetailParams } from 'types/apis/score';
import { getScoreDetail } from 'apis/score';
import useModal from 'hooks/useModal';

const tableColumns: TTableHeader[] = [
  { name: 'no', label: '번호', width: '60px' },
  { name: 'name', label: '이름', width: '80px' },
  { name: 'loginId', label: '학번', width: '100px' },
  { name: 'phoneNum', label: '연락처', width: '140px' },
  { name: 'firstEvaluationStatus', label: '1차 평가 현황', width: '110px' },
  {
    name: 'firstEvaluationAvgScore',
    label: '1차 평가결과',
    width: '140px',
    onClick: () => {
      return;
    },
  },
  { name: 'secondEvaluationStatus', label: '2차 평가 현황', width: '110px' },
  {
    name: 'secondEvaluationAvgScore',
    label: '2차 평가결과',
    width: '140px',
    onClick: () => {
      return;
    },
  },
  { name: '', label: '', width: '140px' },
];

type TProps = {
  params: TScoreDetailParams;
  data: TScoreTableInfo[];
  paging?: TTablePaging;
  sortBy: string;
  sortDirection: string;
  onClickSort: (sortBy: string) => void;
  isLoading: boolean;
};

const ScoreManagementTable = ({
  params,
  data,
  paging,
  sortBy,
  sortDirection,
  onClickSort,
  isLoading,
}: TProps) => {
  const [detailParams, setDetailParams] = useState<TScoreDetailParams | null>(
    null
  );
  const { openModal } = useModal();

  useQuery(
    ['getScoreDetail', detailParams],
    () => {
      if (detailParams) return getScoreDetail(detailParams);
      return Promise.resolve(null);
    },
    {
      enabled: detailParams !== null,
      onSuccess: (data) =>
        data
          ? openModal({
              element: (
                <ScoreDatail
                  data={data.data}
                  params={detailParams}
                  onClose={() => setDetailParams(null)}
                />
              ),
            })
          : Promise.resolve(null),
      onError: () =>
        openModal({
          title: '성적 상세 조회 실패',
          text: '다시 시도해 주세요.',
        }),
    }
  );

  const renderActions = (row: TScoreTableInfo, headerIndex?: number) => (
    <>
      {headerIndex === 8 && (
        <button
          type="button"
          className={styles.link}
          onClick={() =>
            setDetailParams({
              courseInfoId: params.courseInfoId,
              chartRound: params.chartRound,
              userId: row.userId,
            })
          }
        >
          <span>상세보기</span>
          <ChevronRightIcon
            width={20}
            height={20}
            fill={STYLES_VARIABLES.PURPLE_01}
          />
        </button>
      )}
    </>
  );

  return (
    <TableForm
      data={data}
      columns={tableColumns}
      paging={paging}
      renderActions={renderActions}
      sortBy={sortBy}
      sortDirection={sortDirection}
      onClickSort={onClickSort}
      emptyMessage="등록된 성적이 없습니다."
      isLoading={isLoading}
    />
  );
};

export default ScoreManagementTable;
